// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__28MTa","header":"ReportDetails_header__1T_Wp","title":"ReportDetails_title__3FubJ","left":"ReportDetails_left__23qjG"};